export const translations = {
  DECREASE: {
    en: 'Decrease',
    sv: 'Minska',
    da: 'Reducere',
    fi: 'Vähentää',
    no: 'Redusere',
  },
  INCREASE: {
    en: 'Increase',
    sv: 'Öka',
    da: 'Øge',
    fi: 'Lisääntyä',
    no: 'Øke',
  },
  MAX_VALUE_MESSAGE: {
    en: 'Maximum value is ',
    sv: 'Högsta värde är ',
    da: 'Højeste værdi er',
    fi: 'Korkein arvo on',
    no: 'Høyeste verdi er',
  },
  MIN_VALUE_MESSAGE: {
    en: 'Minimum value is ',
    sv: 'Lägsta värde är ',
    da: 'Laveste værdi er ',
    fi: 'Pienin arvo on ',
    no: 'Laveste verdi er ',
  },
};
